import { Injectable } from '@angular/core';
import { SelectItem } from 'primeng/primeng';

import { AttrOption } from '../../../model/attr/option';
import { Classification } from '../../../model/attr/classification';
import { DataOperationUtil } from '../../../service/util/data-operation.util';
import { NecMultiSelectData } from '../../selects/multi-select/multi-select-data';

@Injectable()
export class NecClassificationOptionSelectService {
  constructor() {
  }

  getMultiSelectData(classification: Classification): NecMultiSelectData {
    let items: SelectItem[] = [];
    for (let option of classification.options) {
      items.push({label: option.name, value: option.id});
    }
    return {
      key: classification.id,
      selectItems: items,
      defaultLabelHead: classification.name,
      defaultLabelContent: 'å¨é¨'
    };
  }

  getSelectedClassificationOptions(classification: Classification, optionIds: number[]): AttrOption[] {
    optionIds = optionIds || [];
    return classification.options.filter(option => DataOperationUtil.arrayIncludes(optionIds, option.id));
  }

  getSelectedValues(multiSelectData: NecMultiSelectData, classificationOptionIds: number[]): string[] {
    let results = [];
    multiSelectData.selectItems.forEach(selectItem => {
      if (DataOperationUtil.arrayIncludes(classificationOptionIds, selectItem.value)) {
        results.push(selectItem.value);
      }
    });
    return results;
  }
}
